import React, { Component } from 'react';
import _ from 'lodash'

class ProposedCell extends Component {

    getTextForList(list) {
        if (list && !_.isEmpty(list)) {
            return list.map((item) => {
                return item['publicId'];
            }).join(', ');
        } else {
            return "";
        }
    }

    getTextForMap(m) {
        //console.log(typeof (m))
        //console.log(m['INCOMING_BILL'])
        let incomingBills = this.getTextForList(m['INCOMING_BILL']);
        let outgoingBills = this.getTextForList(m['OUTGOING_BILL']);
        let salaries = this.getTextForList(m['SALARY']);
        let taxes = this.getTextForList(m['TAX']);
        let restrains = this.getTextForList(m['RESTRAIN']);
        let dividends = this.getTextForList(m['DIVIDEND']);
        let result = "";
        if (incomingBills && !_.isEmpty(incomingBills)) {
            result = result.concat("Bejövő: " + incomingBills);
        }
        if (outgoingBills && !_.isEmpty(outgoingBills)) {
            result = result.concat("Kimenő: " + outgoingBills);
        }
        if (salaries && !_.isEmpty(salaries)) {
            result = result.concat("Fizetés: " + salaries);
        }
        if (taxes && !_.isEmpty(taxes)) {
            result = result.concat("Adó: " + taxes);
        }
        if (restrains && !_.isEmpty(restrains)) {
            result = result.concat("Letiltás: " + restrains);
        }
        if (dividends && !_.isEmpty(dividends)) {
            result = result.concat("Osztalék: " + dividends);
        }
        return result;
    }

    render() {
        return (
            <>
                {this.props.row.proposedOutgoingBillIds && !_.isEmpty(this.props.row.proposedOutgoingBillIds) ?
                    <span>{this.getTextForList(this.props.row.proposedOutgoingBillIds)}</span> : <></>}

                {this.props.row.proposedIncomingBillIds && !_.isEmpty(this.props.row.proposedIncomingBillIds) ?
                    <span>{this.getTextForList(this.props.row.proposedIncomingBillIds)}</span> : <></>}

                {this.props.row.proposed.map && !_.isEmpty(this.props.row.proposed.map) ?
                    <span>{this.getTextForMap(this.props.row.proposed.map)}</span> : <></>}
            </>
        )
    }
}
export default ProposedCell;